import React, { useState, useEffect } from 'react';

function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (consent === null) {
      // Small delay before showing banner for better UX
      const timer = setTimeout(() => setShowBanner(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Here you would enable analytics/tracking cookies
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
    // Here you would disable analytics/tracking cookies
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-labelledby="cookie-title" aria-describedby="cookie-desc">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h4 id="cookie-title">Cookie Preferences</h4>
          <p id="cookie-desc">
            We use cookies to enhance your browsing experience and analyse site traffic. 
            By clicking "Accept", you consent to our use of cookies.
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button 
            type="button" 
            className="cookie-btn cookie-btn-reject"
            onClick={handleReject}
          >
            Reject
          </button>
          <button 
            type="button" 
            className="cookie-btn cookie-btn-accept"
            onClick={handleAccept}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
